module.exports = __webpack_public_path__ + "static/media/anger.791276c5.svg";